<template>
    <div class="tradingview-widget-container">
      <div ref="widgetContainer" class="tradingview-widget-container__widget"></div>
      </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  
  export default {
    setup() {
      const widgetContainer = ref(null);
  
      onMounted(() => {
        const script = document.createElement('script');
        script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
        script.async = true;
        script.innerHTML = JSON.stringify({
          "symbols": [
          {
        "proName": "FOREXCOM:SPXUSD",
        "title": "S&P500"
      },
      {
        "proName": "BITSTAMP:BTCUSD",
        "title": "Bitcoin"
      },
      {
        "description": "RBC",
        "proName": "TSX:RY"
      },
      {
        "description": "Shopify",
        "proName": "TSX:SHOP"
      },
      {
        "description": "Air Canada",
        "proName": "TSX:AC"
      },
      {
        "description": "Tesla",
        "proName": "NASDAQ:TSLA"
      },
      {
        "description": "Apple",
        "proName": "NASDAQ:AAPL"
      },
  
          ],
          "showSymbolLogo": true,
          "colorTheme": "light",
          "isTransparent": false,
          "displayMode": "adaptive",
          "locale": "en"
        });
  
        widgetContainer.value.appendChild(script);
      });
  
      return { widgetContainer };
    }
  };
  </script>
<style scoped>

  
.tradingview-widget-container__widget {
  width: 100%;
  animation: scroll-left 20s linear infinite;
}
  
  @keyframes scroll-right {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }

  
  </style>
  